<template>
  <CommonDrop
    v-model="currentValue"
    url="/trade/company/account/list"
    :autoDefault="false"
    :filterable="true"
    :remote="true"
    :size="size"
    :clearable="clearable"
    label-name="accountName"
    remoteSearchKey="name"
  ></CommonDrop>
</template>
<script>
import CommonDrop from "@/components/CommonDrop";
export default {
  components: { CommonDrop },
  name: "CompanyAccount",
  props: {
    value: {
      type: String | Number,
      default: null,
    },
    size:{
      type:String,
      default:'mini'
    },
    clearable:{
      type:Boolean,
      default:false
    }
  },
  computed: {
    currentValue: {
      get() {
        if (this.value === null || this.value === undefined) {
          return "";
        }
        return String(this.value);
      },
      set(newVal) {
        this.$emit("input", newVal);
        this.$emit("change", newVal);
      },
    },
  },
  methods: {},
};
</script>
